import styles from './Home.module.sass';
import Overview from './Overview';
import RegistrationReport from './Overview/RegistrationReport';
import UserRankReports from './Overview/UserRankReport';

const Home = () => {
  return (
    <>
      <div className={styles.row}>
        <div className={styles.col}>
          <Overview className={styles.card} />
          <RegistrationReport className={styles.card} />
          <UserRankReports className={styles.card} />
        </div>
      </div>
    </>
  );
};

export default Home;
